export default "__VITE_ASSET__Cfvk9Q6___"